import { render } from "./companyReviews.vue?vue&type=template&id=18760eb5"
import script from "./companyReviews.vue?vue&type=script&lang=js"
export * from "./companyReviews.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__